import { render, staticRenderFns } from "./clipper.vue?vue&type=template&id=7e224e94&scoped=true"
import script from "./clipper.vue?vue&type=script&lang=js"
export * from "./clipper.vue?vue&type=script&lang=js"
import style0 from "./clipper.vue?vue&type=style&index=0&id=7e224e94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e224e94",
  null
  
)

export default component.exports